module.exports = __webpack_public_path__ + "img/2.68f62ca8.svg";